import { StyleSheet, Text, View } from 'react-native';
import { theme } from '@/constants/theme';

export default function ProfileCard({ name, role, meta }: { name: string; role: string; meta: string }) {
  return (
    <View style={s.card}>
      <View style={s.avatar}><Text style={s.avatarText}>{name.charAt(0)}</Text></View>
      <View style={{ flex: 1 }}>
        <Text style={s.name}>{name}</Text>
        <Text style={s.role}>{role}</Text>
        <Text style={s.meta}>{meta}</Text>
      </View>
    </View>
  );
}

const s = StyleSheet.create({
  card: { flexDirection: 'row-reverse', alignItems: 'center', gap: 12, backgroundColor: '#13172A', borderColor: '#2A315A', borderWidth: 1, borderRadius: 18, padding: 12, marginHorizontal: 20, marginBottom: 18 },
  avatar: { width: 44, height: 44, borderRadius: 22, backgroundColor: theme.colors.primary, alignItems: 'center', justifyContent: 'center' },
  avatarText: { color: '#fff', fontFamily: theme.fonts.bold, fontSize: 18 },
  name: { color: '#fff', fontFamily: theme.fonts.bold, textAlign: 'right' },
  role: { color: '#9CA9D7', fontFamily: theme.fonts.medium, textAlign: 'right', fontSize: 13 },
  meta: { color: '#7E88B4', fontFamily: theme.fonts.regular, textAlign: 'right', fontSize: 12, marginTop: 2 },
});
